const headers = {
  name: "Journal List",
  pagination: {
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  },
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search by reference, description, account name...",
      value: "",
    },
    {
      type: "add",

      text: "New Entry",
      path: "/app/accounting/manual-journals/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Journal List",
        path: "",
      },
      {
        name: "Add",
        path: "/app/accounting/manual-journals/add",
      },
    ],
  },
};

export default headers;
